import React from 'react'
import { PermissionGroup } from '../components/permissionGroup'
import { Permission, UserRole } from 'settings/schema'
import {
    UserRoleSection,
    ProductPermissionsSection,
    OrderPermissionsSection,
    CartPermissionsSection,
} from '../sections'
import { LucideIcon } from 'utils/lucideIcon'
import './general.scss'
import { useTranslation } from 'translations'

interface GeneralPermissionGroupProps {
    userRole: UserRole
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
    handleAdminClick: (granted: boolean) => void
}

export const GeneralPermissionGroup = ({
    userRole,
    isAdminGranted,
    handlePermissionClick,
    handleAdminClick,
}: GeneralPermissionGroupProps) => {
    const { t } = useTranslation()

    return (
        <PermissionGroup className="general-permissions">
            <div className="section-title">{t('settings.users.form.groups.shared')}</div>
            <div className="permission-info-box">
                <LucideIcon iconName="Info" size={16} />
                <span>{t('settings.users.form.groups.sharedInfo')}</span>
            </div>
            {(userRole === 'admin' || userRole === 'user') && (
                <UserRoleSection isAdminGranted={isAdminGranted} handleAdminClick={handleAdminClick} />
            )}
            <ProductPermissionsSection
                userRole={userRole}
                isAdminGranted={isAdminGranted}
                handlePermissionClick={handlePermissionClick}
            />
            <OrderPermissionsSection
                userRole={userRole}
                isAdminGranted={isAdminGranted}
                handlePermissionClick={handlePermissionClick}
            />
            {userRole !== 'reseller' && (
                <CartPermissionsSection isAdminGranted={isAdminGranted} handlePermissionClick={handlePermissionClick} />
            )}
        </PermissionGroup>
    )
}
